// extracted by mini-css-extract-plugin
export var logo = "_ld-2";
export var logoWrapper = "_ld-1";
export var strip = "_ld-0";